import { render, staticRenderFns } from "./FaqSubFooter.vue?vue&type=template&id=44276342&"
import script from "./FaqSubFooter.vue?vue&type=script&lang=js&"
export * from "./FaqSubFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports